import { dashboardInfoQueryOptions } from '@/src/queries/activity-queries'
import { getCurrentYearWeek } from '@/src/utils/year-week'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { StatisticsMetricCard } from '../StatisticsMetricCard'
import { STATISTICS_CARD_PLACEHOLDER_VALUE } from './statistics-card.constants'

export function TotalExercisesMetricCard() {
  const { t } = useTranslation(['statistics', 'common'])
  const yearWeek = getCurrentYearWeek()
  const dashboardInfoQuery = useSuspenseQuery(
    dashboardInfoQueryOptions(yearWeek),
  )
  const totalExercisesCompleted = dashboardInfoQuery.data.total
  const value =
    totalExercisesCompleted == null
      ? STATISTICS_CARD_PLACEHOLDER_VALUE
      : `${totalExercisesCompleted} ${t('statistics:exercise_unit', {
          count: totalExercisesCompleted,
        })}`

  return (
    <StatisticsMetricCard
      id="total"
      title={t('statistics:metric_total_title')}
      value={value}
      timeframe={t('statistics:timeframe_since_start')}
      iconName="exercise"
    />
  )
}
